import { UnitLocation } from "@covertree/agent-portal-graphql";

export function mapUnitLocationLabel(value: UnitLocation): string {
  switch (value) {
    case UnitLocation.LargeManufacturedHome:
      return "Large";
    case UnitLocation.SmallManufacturedHome:
      return "Small";
    case UnitLocation.OnMyOwnLand:
      return "Private land";
    case UnitLocation.Unknown:
      return "Unknown";
  }
}
